import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";
import { Button, Row, Col, Form } from "react-bootstrap";
import RemoveButton from "~/components/Buttons/RemoveButton";
import { TextField } from "@material-ui/core";

function CvMgrDocumentConfiguration({
  setIsEditing,
  cvMgrConfigurationState,
  handleUpdate,
  deleteDoc,
  index,
  handlePromptButtonClick,
}) {
  return (
    <>
      <div
        style={{
          background: "whitesmoke",
          borderRadius: "10px",
          padding: "1rem",
          margin: "1rem 0rem",
        }}
      >
        <Row>
          <Col lg="3" md="12" sm="12">
            <Form.Label>Tipo de Documento</Form.Label>
            <Form.Control
              type="text"
              value={cvMgrConfigurationState.documentType}
              onChange={(e) => {
                handleUpdate("documentType", e.target.value);
                setIsEditing(true);
              }}
              autoComplete="off"
            />
          </Col>
          <Col lg="7" md="12" sm="12">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              type="text"
              value={cvMgrConfigurationState.documentDescription}
              onChange={(e) => {
                handleUpdate("documentDescription", e.target.value);
                setIsEditing(true);
              }}
              autoComplete="off"
            />
          </Col>
          <Col style={{ textAlignLast: "right" }}>
            <RemoveButton text="Remove" onClick={() => deleteDoc(index)} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <Form.Label>Campos para Prompt</Form.Label>
            <div
              style={{
                border: "1px solid #ced4da",
                borderRadius: "23px",
                padding: "1rem",
                backgroundColor: "white",
              }}
            >
              <TextField
                multiline
                placeholder="Chave: Valor;"
                rows={5}
                variant="outlined"
                fullWidth
                value={cvMgrConfigurationState.fields}
                onChange={(e) => {
                  handleUpdate("fields", e.target.value);
                  setIsEditing(true);
                }}
              />
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col lg="10" md="12" sx="12">
            <Form.Label>Prompt</Form.Label>
            <div
              style={{
                border: "1px solid #ced4da",
                borderRadius: "23px",
                padding: "1rem",
                backgroundColor: "white",
              }}
            >
              <TextField
                multiline
                placeholder="Prompt..."
                rows={3}
                variant="outlined"
                fullWidth
                value={cvMgrConfigurationState.prompt}
                onChange={(e) => {
                  handleUpdate("prompt", e.target.value);
                  setIsEditing(true);
                }}
              />
            </div>
          </Col>
          <Col style={{ placeSelf: "center" }}>
            <Button
              id="button_admin_cvmgrConf_generatePrompt"
              className="card-button"
              onClick={() => handlePromptButtonClick(index)}
            >
              Generate Prompt
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CvMgrDocumentConfiguration;
